export const FETCH_APPOINTMENTDROPDOWN_REQUEST = "FETCH_APPOINTMENTDROPDOWN_REQUEST";
export const FETCH_APPOINTMENTDROPDOWN_SUCCESS = "FETCH_APPOINTMENTDROPDOWN_SUCCESS";
export const FETCH_APPOINTMENTDROPDOWN_FAILURE = "FETCH_APPOINTMENTDROPDOWN_FAILURE";
